import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary-fallback" style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '60vh', padding: '40px 20px',
          textAlign: 'center', fontFamily: "'Nunito', sans-serif",
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          </div>
          <h2 style={{ color: '#1e293b', fontSize: 20, margin: '0 0 8px', fontWeight: 700 }}>
            Oops! Sesuatu tidak kena.
          </h2>
          <p style={{ color: '#64748b', fontSize: 14, margin: '0 0 24px', maxWidth: 400 }}>
            Halaman ini mengalami ralat. Sila muat semula untuk cuba lagi.
          </p>
          <button
            data-testid="error-boundary-reload"
            onClick={() => window.location.reload()}
            style={{
              background: '#2196F3', color: '#fff', border: 'none',
              padding: '12px 32px', borderRadius: 100, fontSize: 14,
              fontWeight: 700, cursor: 'pointer', fontFamily: "'Nunito', sans-serif",
            }}
          >
            Muat Semula
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
